import { Button } from '@ui/components';
import { CirclePlusIcon } from 'lucide-react';
import { FC } from 'react';

interface NewButtonProps {
  onAddNew: () => void;
}

export const NewButton: FC<NewButtonProps> = (props) => {
  const { onAddNew } = props;
  return (
    <Button
      className="h-8 px-2"
      type="button"
      onClick={onAddNew}
    >
      <CirclePlusIcon className="mr-1.5 size-4" />
      New
    </Button>
  );
};
